import { WidthContainer } from '@pata-app/ui-document';
import { Button } from '@pata-app/ui-form';
import { Image } from '@pata-app/ui-media';

import React from 'react';
import { Link } from 'react-router-dom';

import { getEnv } from '../../../../lib/utils/getEnv';
import { BusinessPartnersContainer, ImageContainer, SectionContent } from './businessPartner.styled';

const { VITE_CDN_BASE_URL } = getEnv();

const BusinessPartners = () => {
  return (
    <BusinessPartnersContainer id="newsletter">
      <WidthContainer>
        <SectionContent>
          <h2>
            Online <strong>pet bookings </strong>
            made easy
          </h2>
          <p>Looking for your next pet groomer, trainer, dog walker, or cat sitter?</p>
          <p>
            With Pata, finding and booking pet care services online is easy, free, and just a few clicks away. No more
            back and forth calls or messages — book anytime, anywhere, 24/7.
          </p>
          <p>Discover top-rated local businesses and manage your pet’s appointments, all in one place.</p>
        </SectionContent>
        <ImageContainer>
          <Image src={`${VITE_CDN_BASE_URL}/images/image-ipad-app.webp`} alt="iPad showing Pata Pet website" />
        </ImageContainer>
      </WidthContainer>
    </BusinessPartnersContainer>
  );
};

export default BusinessPartners;
